import { useState } from 'react'
import { AnimatedIcon, AnimatedMenu, Box, Dialog, Grid, Stack } from '@trinity/components'
import { navLinks } from '../shared'
import Menu from './Menu'

function MobileNav() {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <Grid>
      <Box onClick={() => setIsOpen(isOpen => !isOpen)} sx={{ padding: 3 }}>
        <AnimatedIcon open={isOpen} side='top' top={35} />
        <AnimatedIcon open={isOpen} side='bottom' top={45} />
      </Box>
      <Dialog noCloseButton fullScreen open={isOpen} sx={{ zIndex: 1299 }}>
        <Stack justifyContent='center' alignItems='center' spacing={6} sx={{ height: 1 }}>
          {navLinks.map((navLink, index) => (
            <AnimatedMenu key={navLink.title} index={index}>
              <Menu navLink={navLink} setIsOpen={setIsOpen} />
            </AnimatedMenu>
          ))}
        </Stack>
      </Dialog>
    </Grid>
  )
}

export default MobileNav
